import React from "react";
import { useModal } from "../../assets/useModal";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Login from "../Login";

export default function LoginModal() {

	const { closeModal } = useModal();
	const user = useSelector(state => state.session.user && state.session.user.id ? state.session.user : null);

	useEffect(() => {
		if (user) closeModal();
	}, [user, closeModal]);

	return <div className="loginModal" style={{
		padding: 20
	}}>
		<section>
			<h2 style={{
				fontSize: "3rem",
				padding: "10px 0px 30px 0px"
			}}>
				Log in / Sign up
			</h2>
			<div>
				If you'd like to add items to your basket and make a purchase please log in or create an <span className="featureFont" style={{ fontSize: "1.1rem" }}>Orderabl<span className="brand-c">+</span></span> account. Otherwise your basket won't be saved and you won't be able to go through checkout.
				<br /><br />
				<b className="featureFont" style={{ fontSize: "1.1rem" }}>Pro tip:</b> Google &amp; Facebook signup is much quicker.
				<br /><br /><br />
			</div>
			<div>
				<Login />
			</div>
		</section>
	</div>
}